module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALBAMAAABbgmoVAAAAKlBMVEUAAAC0LVq8LVO5LVW6MFS5MFW6L1S6L1S7L1O6L1S6MFS6L1S6L1S6L1RYFKe5AAAADXRSTlMAESIzVWZ3iJmqzN3ux/2k6gAAAEBJREFUCNdjYGBgYgADmwYQyXz6BpizMBbIZT4lxArk6iy0aYgtYGATPnmCxQCkEKSU+QQIMegAmTYFDKwgrQYAHr0OrZFaLU4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/double-arrow-hover.png
// module id = 682
// module chunks = 0